<article
  class="overflow-hidden rounded-xl border bg-white shadow-header"
  aria-label="eJournal packet summary"
>
  @if (eJournal(); as j) {
  <div class="grid gap-x-8 gap-y-4 p-5">
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Notary</span
      >
      <span class="text-sm text-midnight">{{ j.notaryName || '—' }}</span>
    </div>
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >State</span
      >
      <span class="text-sm text-midnight">{{ j.state || '—' }}</span>
    </div>
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Default fee per document</span
      >
      <span class="text-sm font-medium text-midnight">{{
        j.feeCharged === null || j.feeCharged === undefined
          ? '—'
          : (j.feeCharged | currency : 'USD' : 'symbol' : '1.2-2')
      }}</span>
    </div>
    @if (j.utcTimeOfSigning) {
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Signing time</span
      >
      <span class="text-sm text-midnight">{{
        j.utcTimeOfSigning | date : 'short'
      }}</span>
    </div>
    }
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Closing type</span
      >
      <span class="text-sm text-midnight">{{ j.closingType || '—' }}</span>
    </div>
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Platform</span
      >
      <span class="text-sm text-midnight">{{ j.platform || '—' }}</span>
    </div>
    <div class="flex flex-col gap-1 col-span-2">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Status</span
      >
      <div>
        <et-journal-is-final-tag
          [isFinal]="j.isFinal"
        ></et-journal-is-final-tag>
      </div>
    </div>
  </div>
  } @else if (eJournalLoading()) {
  <div
    class="flex flex-col gap-4 justify-center items-center h-full min-h-[256px]"
  >
    <et-atoms-spinner></et-atoms-spinner>
  </div>
  } @else {
  <div
    class="flex flex-col gap-4 justify-center items-center h-full min-h-[256px]"
  >
    <p class="m-0 text-sm text-light">No eJournal found for this packet.</p>
    <button
      class="flex gap-2 items-center normal-case rounded-full btn btn-primary btn-sm"
      (click)="onCreateEJournal()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 4.5v15m7.5-7.5h-15"
        />
      </svg>
      <span>Create eJournal</span>
    </button>
  </div>
  }
</article>
